import { odata } from '../../conf';
import Actions from '../../odata/actions';

const actions = new Actions('driedAbaloneSummary', 'driedAbaloneSummaries');

const customActions = {
  async LOAD_driedAbaloneSummaries({ commit, rootGetters }) {
    const data = await odata.o(rootGetters)
      .get('driedAbaloneSummaries')
      .query({
        $filter: 'IsDeleted eq false AND status ne null',
        $expand: 'StockItem',
      });
    commit('SET_driedAbaloneSummaries', data);
    return data;
  },
  async LOAD_driedAbaloneSummariesByStockItemId({ commit, rootGetters }, stockItemId) {
    const data = await odata.o(rootGetters)
      .get('driedAbaloneSummaries')
      .query({
        $filter: `IsDeleted eq false AND StockItemId eq ${stockItemId}`,
        $expand: 'StockItem',
      });
    commit('SET_driedAbaloneSummaries', data);
    return data;
  },
  async LOAD_driedAbaloneSummary({ commit, rootGetters }, id) {
    const data = await odata.o(rootGetters)
      .get(`driedAbaloneSummaries(${id})`)
      .query({
        $expand: 'Items',
      });
    commit('SET_driedAbaloneSummary', data);
    return data;
  },
};

export default { ...actions, ...customActions };
